import type { NodeViewProps, ProseMirrorAttribute } from "ls/common/tiptap-shims";
import type { BlockWidthAttributes } from "../extensions/BlockSize";

export interface CanvasScreenshotOptions {

}

export interface CanvasScreenshotAttributesSelf {
  objectId: string;
}

export type CanvasScreenshotAttributes = CanvasScreenshotAttributesSelf & BlockWidthAttributes;

export const CanvasScreenshotNodeName = "canvasScreenshot";
export type CanvasScreenshotAttributeSpecSelf = Record<keyof CanvasScreenshotAttributesSelf, ProseMirrorAttribute>;
export type CanvasScreenshotAttributeSpec = Record<keyof CanvasScreenshotAttributes, ProseMirrorAttribute>;
export type CanvasScreenshotViewProps = NodeViewProps<CanvasScreenshotOptions, CanvasScreenshotAttributes>;
